import { Fragment, createRef, h } from "preact";
import { SHOPPING_CART_EVENTS } from "./shopping-cart-constants";
import { getBaseBuilderUrl } from "../Helpers/subscription-builder.helpers";
import { dispatchMbbAddProduct, parseMbbBundle } from "../Helpers/mbb-add-product";
import { productPageType, ShoppingCartTransferModel } from "../shop-types";
import { AddOfferingButtonFrontPageTracking } from "@shared/Analytics/content/frontpage-analytics";
import { getAnalyticsListName } from "@shared/Analytics/ecommerce/voice/voice-analytics-utils";
import { getClosestProductTrackingContainerValue } from "@shared/Utils/analytics-utils";

export interface AddServiceButtonModel {
  blockid: string;
  sessionid: string;
  classname?: string;
  buttonclassname?: string;
  buttontext?: string;
  ariabuttonlabel?: string;
  dataid?: string;
  productname: string;
  productpage: productPageType;
  analyticslistname?: string;
  mbbbundle?: string;
}

export const resolveAnalyticsListName = (
  analyticsListName: string | undefined,
  triggerElement: HTMLElement | null,
): string => {
  if (analyticsListName?.trim()) {
    return analyticsListName;
  }

  const closestTrackingContainer = getClosestProductTrackingContainerValue(triggerElement as HTMLElement);

  if (closestTrackingContainer?.trim()) {
    return closestTrackingContainer;
  }

  return getAnalyticsListName();
};

export const AddOfferingButton = () => {
  // can not use anonumous funksjon her - linter fail with message: Component definition is missing display name react/display-name
  const buildButton = ({
    blockid,
    sessionid,
    buttontext,
    classname,
    buttonclassname,
    ariabuttonlabel,
    dataid,
    productname,
    productpage,
    analyticslistname,
    mbbbundle,
  }: AddServiceButtonModel) => {
    const linkButtonRef = createRef<HTMLButtonElement>();
    const buttonId = `${productname.replace(" ", "").toLowerCase()}-cart-btn`;

    const trackClick = () =>
      AddOfferingButtonFrontPageTracking(
        linkButtonRef.current as HTMLButtonElement,
        buttontext ?? "",
        ariabuttonlabel ?? "",
      );

    const addToCart = () => {
      const isFrontPage = window.location.pathname === "/" || window.location.pathname === "/bedrift/";
      const resolvedAnalyticsListName = resolveAnalyticsListName(analyticslistname, linkButtonRef.current);

      if (mbbbundle) {
        dispatchMbbAddProduct(
          parseMbbBundle(mbbbundle),
          linkButtonRef.current as HTMLElement,
          resolvedAnalyticsListName,
        );
        trackClick();
        return;
      }

      const sendModel: ShoppingCartTransferModel = {
        blockId: blockid,
        sessionId: sessionid,
        openButton: linkButtonRef.current as HTMLElement,
        openFromShoppingCart: false,
        update: false,
        baseUrl: getBaseBuilderUrl(),
        adding: true,
        productPage: isFrontPage ? "frontpage" : productpage,
        preselectServiceId: "",
        analyticsListname: resolvedAnalyticsListName,
      };
      document.dispatchEvent(new CustomEvent(SHOPPING_CART_EVENTS.OPEN_SERVICE_SELECTOR_VIEW, { detail: sendModel }));
      trackClick();
    };

    return (
      <Fragment>
        <span className={`${classname ? classname : ""}`}>
          <button
            type="button"
            id={buttonId}
            className={buttonclassname}
            onClick={addToCart}
            ref={linkButtonRef}
            aria-label={ariabuttonlabel}
            data-id={dataid}
            data-enable-cta-click-tracking
            data-cta-tracking-category="legg_til"
            data-button-label={buttontext}
          >
            {buttontext}
          </button>
        </span>
      </Fragment>
    );
  };
  return buildButton;
};
